import './ServicesScreen.css'
import PageHeader from '../../components/PageHeader/PageHeader'
import ServicesList from '../../components/Services/ServicesList'

const ServicesScreen = () => {
  return (
    <div className="services-screen">
      <PageHeader
        eyebrow="Þjónusta"
        title="Þjónusta sem byggir á gæðum og reynslu"
        lede="Við bjóðum fjölbreytta þjónustu sem uppfyllir þarfir sjávarútvegs og iðnaðar, allt frá stálsmíði og rennismíði til viðgerða og sérsmíðinna lausna."
      />
      <ServicesList />
    </div>
  )
}

export default ServicesScreen
